import { inject, prop } from "fw";

import { DateFormatter, DateFormatContext } from "helpers/date-formatter";

@inject
export class FormattedDate {
    @prop(null) private date!: any;
    @prop(null) private timezone!: string;
    @prop("MMM D, YYYY") private format!: string;
    @prop(false) private fromNow!: boolean;
    @prop(false) private withSuffix!: boolean;
    @prop(false) private fromUtc!: boolean;
    @prop(false) private calendar!: boolean;
    @prop(false) private dateOnly!: boolean;

    private dateFormatter: DateFormatter = new DateFormatter();

    get formatted() {
        const context: DateFormatContext = {
            format: this.format,
            fromNow: this.fromNow,
            withSuffix: this.withSuffix,
            timezone: this.timezone,
            fromUtc: this.fromUtc,
            calendar: this.calendar,
            dateOnly: this.dateOnly
        };

        return this.dateFormatter?.formatDate(this.date, context);
    }

    get timestamp() {
        if (!this.date) return null;
        const context: DateFormatContext = {
            format: "" // standard ISO format
        };
        return this.dateFormatter?.formatDate(this.date, context);
    }
}
